<template>
  <vxe-table
    ref="xtab"
    border
    resizable
    width="100%"
    :data="listArr"
    :edit-config="{trigger: 'click', mode: 'row'}"
    @cell-click="cellClickEvent"
    @select-all="selectAllEvent" 
    @select-change="selectChangeEvent"
    >
    <vxe-table-column type="checkbox" width="60"></vxe-table-column>
    <template v-for="(item,index) in columns">
      <vxe-table-column v-if="item.isEdit" :field="item.field" :width="item.width" :title="item.title" :edit-render="{name:item.type}"></vxe-table-column>
      <vxe-table-column v-else :field="item.field" :title="item.title" :width="item.width" :formatter="item.formatter"></vxe-table-column>
    
    </template>
  </vxe-table>
</template>

<script>

export default {
  props:{
    columns:Array,//表头
    listArr:Array,//数据
  },
  data () {
    return {
      sexList: [],
      checkedList:[],//已选中的数据
    }
  },
  created () {
    
  },
  methods: {
    cellClickEvent () {
      console.log('单元格点击事件')
    },
    //全选改变
    selectAllEvent ({ checked }) {
      console.log(checked ? '所有勾选事件' : '所有取消事件')
    },
    //改变选中状态
    selectChangeEvent ({ checked, row }) {
      //console.log(checked ? '勾选事件' : '取消事件');
    },
    //获取选中的
    getSelectEvent () {
      let selectRecords = this.$refs.xtab.getCheckboxRecords();
      this.checkedList = selectRecords;
      console.log(this.checkedList);
    }
  }
}

</script>

<style>
</style>
